<div class="table-container" [class.empty-table-container]="!loaderFlag && rows.length === 0">
  @if (apiLoading) {
  <div class="loader-container">
    <loading></loading>
  </div>
  } @else {

  <!-- Overlay spinner while table data is being fetched (filters, search, load more) -->
  @if (isTableDataLoading && !loaderFlag) {
  <div class="table-loading-overlay" aria-hidden="true">
    <div class="table-loading-spinner">
      <img class="loading-spinner-icon" [src]="'assets/icons/loading.svg'" alt="Loading">
      <span class="table-loading-text">Loading data...</span>
    </div>
  </div>
  }

  <ngx-datatable *ngIf="!loaderFlag" [rows]="rows" [columns]="columns" [columnMode]="ColumnMode.force"
    class="material server-scrolling-demo table-class" [class.empty-table]="rows.length === 0"
    [footerHeight]="32" [headerHeight]="headerHeight"
    [rowHeight]="rowHeight" [loadingIndicator]="isLoading" [ghostLoadingIndicator]="isLoading" headerClass="is-gender"
    [scrollbarV]="true" (scroll)="onScroll($event.offsetY)" [scrollbarH]="true"
    [rowClass]="getRowClass">

    <ngx-datatable-column name="#" [width]="60" [maxWidth]="200">
      <ng-template ngx-datatable-header-template>
        <div class="selector-header">
          <div class="custom-checkbox"
               [class.checked]="isAllSelected()"
               [class.indeterminate]="isIndeterminate()"
               (click)="onSelectAll(!isAllSelected())"
               [class.disabled]="rows.length === 0">
            <!-- Checked state -->
            <img *ngIf="isAllSelected()" src="assets/icons/checkbox-checked.svg" alt="All selected" class="checkbox-icon">
            <!-- Indeterminate state -->
            <img *ngIf="isIndeterminate()" src="assets/icons/checkbox-indeterminate.svg" alt="Some selected" class="checkbox-icon">
            <!-- Unchecked state -->
            <img *ngIf="!isAllSelected() && !isIndeterminate()" src="assets/icons/checkbox-unchecked.svg" alt="None selected" class="checkbox-icon">
          </div>
        </div>
      </ng-template>
      <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
        <div class="row-index-container"
             (mouseenter)="onRowHover(row, true)"
             (mouseleave)="onRowHover(row, false)">
          <div class="row-number" *ngIf="!isRowSelected(row) && !isRowHovered(row)">
            {{ rowIndex + 1 }}
          </div>
          <div class="row-checkbox" *ngIf="isRowSelected(row) || isRowHovered(row)">
            <div class="custom-checkbox"
                 [class.checked]="isRowSelected(row)"
                 (click)="onRowSelect(row, !isRowSelected(row))"
                 [class.disabled]="!row['ContactId']">
              <!-- Checked state -->
              <img *ngIf="isRowSelected(row)" src="assets/icons/checkbox-checked.svg" alt="Selected" class="checkbox-icon">
              <!-- Unchecked state -->
              <img *ngIf="!isRowSelected(row)" src="assets/icons/checkbox-unchecked.svg" alt="Not selected" class="checkbox-icon">
            </div>
          </div>
        </div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column *ngFor="let col of columns; trackBy: trackByFn; index as idx" [name]="col.name ?? ''"
      [width]="getColumnWidth(col.prop)" [prop]="col?.prop ?? ''" (columnReorder)="onColumnReorder($event)">
      <ng-template ngx-datatable-header-template>
        <div class="column-header-label">
          <span>{{ col.name }}</span>
          <span *ngIf="isClusteredColumn(col.prop)" class="cluster-col-badge" title="Grouped cluster value">Cluster</span>
        </div>
      </ng-template>
      <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
        <!-- Custom template for free-form Topics array column -->
        <div *ngIf="col.prop === 'Topics'; else clusteredOrOther">
          <div class="topics-container1" (click)="handleCellClick()">
            <div *ngIf="rows[rowIndex][col?.prop ?? ''] && rows[rowIndex][col?.prop ?? ''].length > 0"
              class="topics-container">
              <ng-container *ngFor="let topic of rows[rowIndex][col?.prop ?? '']; let i = index">
                <span [ngClass]="topic === 'NA' || topic === '' ? 'default-topic-class' : (i | topicClass)">
                  {{ topic | truncateTopic }}
                </span>
              </ng-container>
            </div>
          </div>
        </div>

        <ng-template #clusteredOrOther>
          <div *ngIf="isClusteredColumn(col.prop); else otherColumns">
            <div class="topics-container1" (click)="handleCellClick()">
              <div *ngIf="getClusterCellValues(rows[rowIndex][col?.prop ?? '']).length > 0" class="topics-container">
                <span
                  *ngFor="let value of getClusterCellValues(rows[rowIndex][col?.prop ?? ''])"
                  class="cluster-value-chip"
                  [matTooltip]="value">
                  {{ value | truncateTopic }}
                </span>
              </div>
              <span *ngIf="getClusterCellValues(rows[rowIndex][col?.prop ?? '']).length === 0">NA</span>
            </div>
          </div>
        <!-- Fallback to handle other columns -->
        <ng-template #otherColumns>

          <!-- Handle Date column with formatting -->
          <div *ngIf="col.prop === 'Date'; else checkAgentConnectedToAgentTimestamp" (click)="handleCellClick()">
            {{ (row[col.prop] && row[col.prop] !== 'NA' && row[col.prop] !== 'null' && row[col.prop] !== '') ?
            (row[col.prop] | formatDate) : 'NA' }}
          </div>

          <!-- Handle all timestamp columns with formatting -->
          <ng-template #checkAgentConnectedToAgentTimestamp>
            <div
              *ngIf="(col.prop === 'Agent_ConnectedToAgentTimestamp' ||
                      col.prop === 'ContactTimestamp' ||
                      col.prop === 'PNRCreationDate' ||
                      col.prop === 'UpcomingFlightDate' ||
                      col.prop === 'Agent_AfterContactWorkEndTimestamp' ||
                      col.prop === 'Agent_AfterContactWorkStartTimestamp' ||
                      col.prop === 'ConnectedToSystemTimestamp' ||
                      col.prop === 'DisconnectTimestamp' ||
                      col.prop === 'InitiationTimestamp' ||
                      col.prop === 'LastUpdateTimestamp' ||
                      col.prop === 'Queue_DequeueTimestamp' ||
                      col.prop === 'Queue_EnqueueTimestamp' ||
                      col.prop === 'Recordings_0_StartTimestamp' ||
                      col.prop === 'Recordings_0_StopTimestamp' ||
                      col.prop === 'ScheduledTimestamp' ||
                      col.prop === 'TransferCompletedTimestamp' ||
                      col.prop === 'Attributes_callbackDeQueuedTime' ||
                      col.prop === 'Attributes_callbackEnQueuedTime'); else checkAgentInteractionDuration"
              (click)="handleCellClick()">
              {{ (row[col.prop] && row[col.prop] !== 'NA' && row[col.prop] !== 'null' && row[col.prop] !== '') ?
              (row[col.prop] | dataViewTimestampFormat:(row['timezone'] || sharedDataService.selectedTimezoneValue || '')) : 'NA' }}
            </div>
          </ng-template>

          <ng-template #checkAgentInteractionDuration>
            <div *ngIf="col.prop === 'Agent_AgentInteractionDuration'; else checkHoldDuration" (click)="handleCellClick()">
              {{ row[col.prop] && row[col.prop] !== 'NA' ? (row[col.prop] | formatTimestamp) : 'NA' }}
            </div>
          </ng-template>


          <ng-template #checkHoldDuration>
            <div *ngIf="col.prop === '  Agent_CustomerHoldDuration'; else checkForSentiment" (click)="handleCellClick()">
              {{ row[col.prop] && row[col.prop] !== 'NA' ? (row[col.prop] | formatTimestamp) : 'NA' }}
            </div>
          </ng-template>

          <!-- Handle Customer Sentiment columns -->
          <ng-template #checkForSentiment>
            <div *ngIf="
                  (col?.prop ?? '') === 'CustomerSentimentAtEnd' || (col?.prop ?? '') === 'CustomerSentimentAtStart';
                  else handleLongTextWithTooltip
                " (click)="handleCellClick()">
              <div [ngClass]="row[col?.prop ?? ''] | sentimentClass">
                {{ row[col?.prop ?? ''] | sentimentText }}
              </div>
            </div>
          </ng-template>

          <!-- Handle long text with tooltip -->
          <ng-template #handleLongTextWithTooltip>
            <div *ngIf="
                  row[col?.prop ?? '']?.toString()?.length > 25 && col.prop != 'Date' && col.prop != 'Topics' && col.prop != 'TopicsClustered';
                  else simpleText
                " (click)="handleCellClick()">
              <div matTooltip="{{ row[col?.prop ?? ''] }}">
                {{ row[col?.prop ?? '']?.toString()
                }}
              </div>
            </div>

            <!-- Default simple text handler -->
            <ng-template #simpleText >
              <div class="log-cell" (click)="handleCellClick()">
                <span>{{ row[col?.prop ?? ''] || 'NA'}}</span>

                <!-- Copy to Clipboard button (always visible) -->
                <!-- <button mat-icon-button class="copy-button" matTooltip="Copy to Clipboard"
                   >
                    <mat-icon class="content-copy-icon">content_copy</mat-icon>
                  </button> -->
              </div>
            </ng-template>
          </ng-template>
        </ng-template>
        </ng-template>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-footer *ngIf="true">
      <ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize"
        let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset">

        <!-- Show selected count when there are selections -->
        <div class="selected-count-info" *ngIf="hasSelections()">
          <img src="assets/icons/info-icon.svg" alt="info" class="info-icon">
          <span>{{ getSelectedCount() }} / 50 records selected</span>
        </div>

        <!-- Show regular record count when no selections -->
        <div class="row-count" *ngIf="commonService.rowValue > 0 && !hasSelections()">
          <div>{{ rowCount }} records</div>
        </div>

        <div class="row-count" *ngIf="commonService.rowValue == 0">
          <div>No record found</div>
        </div>
      </ng-template>
    </ngx-datatable-footer>
  </ngx-datatable>
  }

  <!-- Loader: only show when not already showing the full-page apiLoading loader -->
  <div *ngIf="loaderFlag && !apiLoading" class="main-view-container-loader">
    <img class="loading-spinner-icon" [src]="'assets/icons/loading.svg'" alt="Loading">
    <div style="margin-left: 8px;">Loading...</div>
  </div>
